export default __webpack_public_path__ + "static/media/dark-legacies-first-contact.d3ecb74b.jpg";